/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

var COLOR_MAP = {
  blue: "var(--td-brand-color)",
  red: "var(--td-error-color)",
  orange: "var(--td-warning-color)",
  green: "var(--td-success-color)"
};
function getFormatValue(value, decimalPlaces, separator) {
  var options = {
    minimumFractionDigits: decimalPlaces !== null && decimalPlaces !== void 0 ? decimalPlaces : 0,
    maximumFractionDigits: decimalPlaces !== null && decimalPlaces !== void 0 ? decimalPlaces : 20,
    useGrouping: !!separator
  };
  return value.toLocaleString(void 0, options).replace(/,|，/g, separator);
}

export { COLOR_MAP, getFormatValue };
//# sourceMappingURL=utils.mjs.map
